import { FaArrowRightLong } from "react-icons/fa6";
import { CiClock2 } from "react-icons/ci";
import { Link } from "react-router-dom";

const BlogCard = ({ index, img, profile, date, title, id }) => {
  return (
    <Link data-aos="fade-up" data-aos-duration="1000" data-aos-delay={index * 100} to={`/blog/${id}`} className="snap-center bg-white shrink-0 rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 lg:w-[320px] inline-block md:w-[21.5rem] w-full group border border-transparent hover:border-[#0FA3E2]/30">

      <div className="relative w-full h-[200px] overflow-hidden">
        <img
          src={img}
          alt={title}
          className="w-full h-full object-cover transition-all duration-500 group-hover:scale-110"
        />

        <img
          src={profile}
          alt="profile"
          className="w-12 h-12 rounded-full object-cover border-2 border-white absolute bottom-3 right-3 shadow-md"
        />
      </div>

      <div className="px-5 py-4 space-y-4">

        <div className="flex items-center gap-2 text-secondaryTextColor text-sm">
          <CiClock2 className="text-[15px]" />
          <p>{date}</p>
        </div>

        <h3 className="text-[16px] font-semibold leading-6 text-primaryNavyTextColor">
          {title}
        </h3>

        <div className="relative cursor-pointer flex items-center gap-3 w-fit">

          <span className="w-9 h-9 rounded-full bg-primaryColor text-white flex items-center justify-center transition-all duration-500 group-hover:w-[110px]">
            <span className="absolute left-10 opacity-0 group-hover:opacity-100 text-white text-sm font-semibold whitespace-nowrap transition-all duration-500 group-hover:left-5">
              READ MORE
            </span>
            <FaArrowRightLong className="transition-all inline-block duration-500 group-hover:translate-x-16 group-hover:opacity-0 group-hover:pointer-events-none" />
          </span>
        </div>

      </div>
    </Link>
  );
};

export default BlogCard;
